import { StringParam, useQueryParams, withDefault } from 'use-query-params'

export const useTaxiparkQueryParams = () => {
  const [{ xTaxiparkKey: xTaxiparkKeyQuery, taxiparkId: taxiparkIdQuery }] =
    useQueryParams({
      xTaxiparkKey: withDefault(StringParam, ''),
      taxiparkId: withDefault(StringParam, ''),
    })

  return { xTaxiparkKeyQuery, taxiparkIdQuery }
}
